import { makeStyles } from "@material-ui/core"

const useStyles = makeStyles(theme => ({
	container: {
		height: "100%",
		width: "100%"
	},
	wrapper: {
		margin: "auto 0",
		maxWidth: "100%",
		flexBasis: "100%"
	},
	portlet: {
		padding: `${theme.spacing(5)}px 10%`
	}
}))

export default useStyles
